module.exports = __webpack_public_path__ + "static/media/info-circle.d0766663.svg";